export var CupItemSymbol = Symbol('CupItem');
export var TeaItemSymbol = Symbol('TeaItem');
